<nav
  *ngIf="breadcrumbs().length"
  class="breadcrumb-container"
  [class.has-ticket-controls]="ticketDashboardHeader.state()"
  [class.has-raise-action]="showRaiseTicketAction()"
  [class.has-audit-actions]="auditLogHeader.active()"
  [class.has-user-actions]="userListHeader.active()"
  aria-label="Breadcrumb">
  <div class="breadcrumb-trail flex align-items-center flex-wrap gap-2">
    <ng-container *ngFor="let item of breadcrumbs(); let last = last">
      <a *ngIf="item.route && !last; else breadcrumbLabel" [routerLink]="item.route">
        {{ item.label }}
      </a>

      <ng-template #breadcrumbLabel>
        <strong *ngIf="last; else plainLabel">{{ item.label }}</strong>
        <ng-template #plainLabel><span>{{ item.label }}</span></ng-template>
      </ng-template>

      <i *ngIf="!last" class="pi pi-angle-right breadcrumb-separator" aria-hidden="true"></i>
    </ng-container>
  </div>

  @if (showDashboardFilters()) {
    <div class="dashboard-command-bar">
      <div class="dashboard-controls flex align-items-end gap-3">
        <div class="control-field">
          <label for="dashboard-region">Region</label>
          <p-select
            inputId="dashboard-region"
            [options]="regionOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="selectedRegion"
            appendTo="body" />
        </div>

        <div class="control-field accounting-date-field">
          <label for="dashboard-date">Accounting Date</label>
          <p-datepicker
            inputId="dashboard-date"
            [(ngModel)]="selectedDate"
            [showIcon]="true"
            dateFormat="dd M yy"
            appendTo="body" />
        </div>

        <div class="refresh-meta">
          <span><i class="pi pi-clock"></i> Last Refreshed</span>
          <strong>{{ lastRefreshedLabel }}</strong>
        </div>

        <button type="button" class="icon-refresh app-refresh-btn" title="Refresh dashboard" aria-label="Refresh dashboard" (click)="refreshDashboard()">
          <i class="pi pi-refresh"></i>
        </button>
      </div>
    </div>
  }

  @if (ticketDashboardHeader.state(); as controls) {
    <div class="ticket-command-bar">
      <div class="ticket-controls">
        <div class="control-field ticket-rldc-field">
          <label for="ticket-header-rldc">RLDC</label>
          <p-select
            inputId="ticket-header-rldc"
            [options]="controls.rldcOptions"
            optionLabel="label"
            optionValue="id"
            appendTo="body"
            placeholder="Select RLDC"
            [ngModel]="controls.rldcId"
            (ngModelChange)="ticketDashboardHeader.changeRldc($event)" />
        </div>

        <div class="control-field ticket-date-field">
          <label for="ticket-header-date-range">Date Range</label>
          <p-datepicker
            inputId="ticket-header-date-range"
            [ngModel]="controls.dateRange"
            (ngModelChange)="ticketDashboardHeader.changeDateRange($event)"
            selectionMode="range"
            [showIcon]="true"
            appendTo="body"
            placeholder="From Date - To Date" />
        </div>

        <div class="ticket-actions">
          <button type="button" class="ticket-header-btn primary" (click)="ticketDashboardHeader.apply()">Apply</button>
          <button type="button" class="ticket-header-btn outline" (click)="ticketDashboardHeader.reset()">Reset</button>
        </div>
      </div>
    </div>
  }

  @if (showRaiseTicketAction()) {
    <button
      type="button"
      class="breadcrumb-back-action"
      [routerLink]="['/tickets/dashboard']">
      <i class="pi pi-arrow-left" aria-hidden="true"></i>
      <span>Back to Dashboard</span>
    </button>
  }

  @if (auditLogHeader.active()) {
    <div class="audit-header-actions">
      <button type="button" class="audit-header-btn" (click)="auditLogHeader.reset()">
        <i class="pi pi-refresh" aria-hidden="true"></i>
        <span>Reset</span>
      </button>
      <button type="button" class="audit-header-btn" (click)="auditLogHeader.export()">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Export</span>
      </button>
    </div>
  }

  @if (userListHeader.active()) {
    <div class="user-header-actions">
      <button type="button" class="user-header-btn primary" (click)="userListHeader.addUser()">
        <i class="pi pi-plus" aria-hidden="true"></i>
        <span>Add User</span>
      </button>
      <button type="button" class="user-header-btn outline" (click)="userListHeader.export()">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Export</span>
      </button>
      <button
        type="button"
        class="user-header-btn refresh app-refresh-btn"
        title="Refresh"
        aria-label="Refresh users"
        (click)="userListHeader.refresh()">
        <i class="pi pi-refresh" aria-hidden="true"></i>
      </button>
    </div>
  }
</nav>
